module.exports = __webpack_public_path__ + "img/sepa_logo.4e769647.svg";